/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState,useEffect } from 'react';
import logo from '../../utils/images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { login, UserDetails } from '../../redux/actions/authActions';
import { TextField, Button, CircularProgress, Alert, Container, Box, Typography } from '@mui/material';
import Loading from '../Loading';
import { Navigate, useNavigate,Link  } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import './Styles.scss';

const LoginComp = () => {

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (e) => {
    e.preventDefault();
  };


  const [formData, setFormData] =useState({ email: '', password: '' });
  const [errors, setErrors] = useState({ email: '', password: '' });
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error,message,user,isLoggedIn,auth_token } = useSelector((state) => state.auth);
  const handleChange = (e) => {
    const {name,value}= e.target;
    setFormData(formData=>({...formData,[name]:value}));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;

    if (!formData.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: 'Email is required' }));
      valid = false;
    }

    if (!formData.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: 'Password is required' }));
      valid = false;
    }

    if (valid) {
      // Handle form submission
      console.log('Form submitted', formData);
      dispatch(login(formData.email, formData.password)); 
     
    }    
  };  
  useEffect(()=>{
      if(auth_token){
        dispatch(UserDetails());
        navigate("/report"); 
      }
  },[auth_token])
  return (
      
    <Box>
       {/*  {
            loading?<Loading />:""
        } */}
        <Box
        className="loginMain"
       
        >
          <Box className="loginBoxInn">
            <Box>
              <img src={logo} alt='' className='logo-img'/>
            </Box>
            <Typography component="h1" variant="h4" mb={2}>
                Login
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate gap={'15px'} display={'flex'} flexDirection={'column'} width={'100%'}>
                <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={formData.email}
                onChange={(e) => {
                    handleChange(e);
                }}
                error={!!errors.email}
                helperText={errors.email}
                />
                <FormControl variant="outlined">
          <InputLabel htmlFor="password">Password</InputLabel>
          <OutlinedInput
            id="password"
            required
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            value={formData.password}
            name="password"
            onChange={(e) => {
              handleChange(e);
            }}
            error={!!errors.password}
            helperText={errors.password}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
                {/* <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={formData.password}
                onChange={(e) => {
                    handleChange(e);
                }}
                error={!!errors.password}
                helperText={errors.password}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                /> */}
                <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                >
                {loading ?  <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Login'}
                </Button>
                <Box textAlign={"right"} style={{ color: '#8BAF91' }}>
                  <Link to="/forgot-password" style={{ color: '#8BAF91' }} variant="body2">
                      Forgot password?
                  </Link>
                </Box>
            </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default LoginComp;
